export enum SearchPostingTypeEnum{
    DANCE_PARTNER = "DANCE_PARTNER",
    DANCE_GROUP = "DANCE_GROUP"
}
